import * as Yup from "yup";
import { dateToyyyyMMdd } from "../../../util/date";
import { getPatchOperations } from "../../../util/form";
export const FirmaSanktionerForm = (
  firmaId: string,
  firmaSanktionId?: string,
): FormConfig<FirmaSanktionerDTO> => {
  return {
    title: "sanktion",
    lockedValues: [
      {
        id: "firmaId",
        value: firmaId,
      },
      {
        id: "firmaSanktionId",
        value: firmaSanktionId,
      },
    ],
    form: [
      {
        component: "textinput",
        id: "sagsNr",
        initialValue: "",
        label: "Sagsnr.",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "naevnskendelseDato",
        initialValue: "",
        label: "Kendelsesdato (nævn)",
        isRequired: true,
      },
      {
        component: "kode-select",
        id: "naevnskendelseSanktionstypeNr",
        label: "Sanktion (nævn)",
        kodeListeType: "Sanktionstype",
        placeholder: "Vælg sanktionstype",
        initialValue: "",
        excludeDeaktiveret: true,
      },
      {
        component: "textinput",
        id: "naevnskendelseBoedebeloeb",
        placeholder: "f.eks. 10000",
        initialValue: "",
        label: "Bødebeløb (nævn)",
      },
      {
        component: "textarea",
        id: "bemaerkninger",
        initialValue: "",
        label: "Bemærkninger",
      },
      {
        component: "textinput",
        id: "sagsLink",
        initialValue: "",
        label: "Kendelse",
      },
      {
        component: "textinput",
        id: "afgoerelseskoder",
        initialValue: "",
        label: "Afgørelseskoder",
      },
      {
        component: "boolean",
        id: "indbragtretten",
        label: "Indbragt",
        initialValue: false,
      },
      {
        component: "datepicker",
        id: "retskendelseDato",
        initialValue: "",
        label: "Domsdato",
        conditionalHidden: ({ method }) => method === "post",
      },
      {
        component: "kode-select",
        id: "retskendelseSanktionstypeNr",
        initialValue: "",
        label: "Sanktion (retten)",
        kodeListeType: "Sanktionstype",
        placeholder: "Vælg sanktionstype",
        excludeDeaktiveret: true,
        conditionalHidden: ({ method }) => method === "post",
      },
      {
        component: "textinput",
        id: "retskendelseBoedebeloeb",
        initialValue: "",
        label: "Bødebeløb (retten)",
        placeholder: "f.eks. 10000",
        conditionalHidden: ({ method }) => method === "post",
      },
    ],
    validationSchema: Yup.object({
      sagsNr: Yup.string().required("Sagsnr. skal være sat"),
      naevnskendelseDato: Yup.date()
        .nullable()
        .required("Kendelsesdato skal være sat"),
      naevnskendelseSanktionstypeNr: Yup.number().required(
        "Sanktion skal være sat",
      ),
      naevnskendelseBoedebeloeb: Yup.number()
        .typeError("Bødebeløb skal være et tal")
        .min(0, "Bødebeløb skal være minimum 0"),
      indbragtretten: Yup.boolean(),
      retskendelseSanktionstypeNr: Yup.number().test(
        "retskendelseSanktionstypeNr",
        'Sanktion (retten) kan ikke være sat, uden at Indbragt er sat til "Ja"',
        function (retskendelseSanktionstypeNr) {
          return !(retskendelseSanktionstypeNr && !this.parent.indbragtretten);
        },
      ),
      retskendelseDato: Yup.date()
        .nullable()
        .test(
          "retskendelseDato",
          'Domsdato kan ikke være sat, uden at Indbragt er sat til "Ja"',
          function (retskendelseDato) {
            return !(retskendelseDato && !this.parent.indbragtretten);
          },
        ),
      retskendelseBoedebeloeb: Yup.number()
        .typeError("Bødebeløb skal være et tal")
        .min(0, "Bødebeløb skal være minimum 0")
        .test(
          "retskendelseBoedebeloeb",
          'Bødebeløb (retten) kan ikke være sat, uden at Indbragt er sat til "Ja"',
          function (retskendelseBoedebeloeb) {
            return !(retskendelseBoedebeloeb && !this.parent.indbragtretten);
          },
        ),
      bemaerkninger: Yup.string(),
      sagsLink: Yup.string(),
      afgoerelseskoder: Yup.string(),
    }),
    get: `firma/${firmaId}/firmasanktioner/${firmaSanktionId}`,
    patch(values: FirmaSanktionerDTO) {
      return {
        query: `firma/${firmaId}/firmasanktioner/${firmaSanktionId}`,
        body: JSON.stringify(getPatchOperations(values)),
      };
    },
    post: (values: FirmaSanktionerDTO) => {
      const {
        naevnskendelseDato,
        retskendelseDato,
        naevnskendelseBoedebeloeb,
        retskendelseSanktionstypeNr,
        retskendelseBoedebeloeb,
        sagsLink,
      } = values;
      const body = {
        ...values,
        naevnskendelseDato: dateToyyyyMMdd(naevnskendelseDato),
        naevnskendelseBoedebeloeb: naevnskendelseBoedebeloeb
          ? naevnskendelseBoedebeloeb
          : null,
        retskendelseSanktionstypeNr: retskendelseSanktionstypeNr
          ? retskendelseSanktionstypeNr
          : null,
        retskendelseBoedebeloeb: retskendelseBoedebeloeb
          ? retskendelseBoedebeloeb
          : null,
        retskendelseDato: retskendelseDato
          ? dateToyyyyMMdd(retskendelseDato)
          : null,
        sagsLink: sagsLink ? sagsLink : null,
      };
      return {
        body,
        query: `firma/${firmaId}/firmasanktioner`,
      };
    },
    delete() {
      return {
        query: `firma/${firmaId}/firmasanktioner/${firmaSanktionId}`,
      };
    },
  };
};
